import { createFileRoute } from '@tanstack/react-router'

import { PlatformAdminPasskeysPage } from '../../../../components/pages/backoffice/platform/platform-admin-passkeys-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/admin/passkeys/')({
  component: () => (
    <PermissionChecker requiredPermissions={['session.access']}>
      <PlatformAdminPasskeysPage />
    </PermissionChecker>
  ),
})
